/* tslint:disable */
/* eslint-disable */
/**
 * Limber Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StatisticsData
 */
export interface StatisticsData {
    /**
     * 
     * @type {number}
     * @memberof StatisticsData
     */
    totalUsers: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsData
     */
    totalSessions: number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof StatisticsData
     */
    programCounts: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof StatisticsData
     */
    sexCounts: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof StatisticsData
     */
    riskCategoryCounts: { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof StatisticsData
     */
    meanAge: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsData
     */
    meanBmi: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsData
     */
    meanBaselinePromisPain: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsData
     */
    meanBaselinePromisFunction: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsData
     */
    meanDifferencePromisPain: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsData
     */
    meanDifferencePromisFunction: number;
}

export function StatisticsDataFromJSON(json: any): StatisticsData {
    return StatisticsDataFromJSONTyped(json, false);
}

export function StatisticsDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatisticsData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalUsers': json['total-users'],
        'totalSessions': json['total-sessions'],
        'programCounts': json['program-counts'],
        'sexCounts': json['sex-counts'],
        'riskCategoryCounts': json['risk-category-counts'],
        'meanAge': json['mean-age'],
        'meanBmi': json['mean-bmi'],
        'meanBaselinePromisPain': json['mean-baseline-promis-pain'],
        'meanBaselinePromisFunction': json['mean-baseline-promis-function'],
        'meanDifferencePromisPain': json['mean-difference-promis-pain'],
        'meanDifferencePromisFunction': json['mean-difference-promis-function'],
    };
}

export function StatisticsDataToJSON(value?: StatisticsData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total-users': value.totalUsers,
        'total-sessions': value.totalSessions,
        'program-counts': value.programCounts,
        'sex-counts': value.sexCounts,
        'risk-category-counts': value.riskCategoryCounts,
        'mean-age': value.meanAge,
        'mean-bmi': value.meanBmi,
        'mean-baseline-promis-pain': value.meanBaselinePromisPain,
        'mean-baseline-promis-function': value.meanBaselinePromisFunction,
        'mean-difference-promis-pain': value.meanDifferencePromisPain,
        'mean-difference-promis-function': value.meanDifferencePromisFunction,
    };
}


